import {Inject, Injectable, Optional} from '@angular/core';
import {Observable} from 'rxjs';
import {GET_DOWNLOAD_URL, GET_VISITOR_DOWNLOAD_URL, IDownloadUrlResponse} from '@shared-models/common.models';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class S3DownloadUrlService {

    constructor(
        @Optional() @Inject(GET_DOWNLOAD_URL) private getDownloadUrl: string,
        @Optional() @Inject(GET_VISITOR_DOWNLOAD_URL) private getVisitorDownloadUrl: string,
        private httpClient: HttpClient,
    ) {
    }

    getUrl(uId: string, isVisitor: boolean = false): Observable<IDownloadUrlResponse> {
        const downloadUrl = isVisitor ? this.getVisitorDownloadUrl : this.getDownloadUrl;
        const url = downloadUrl.replace('{uId}', uId);
        return this.httpClient.get(url) as Observable<IDownloadUrlResponse>;
    }
}
